import React from 'react';
import { LucideIcon, Inbox } from '@/components/icons';
import { cn } from '@/lib/utils';
import { Button } from '@/components/common/Button';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: React.ReactNode;
  /** Custom action node rendered instead of the default actionLabel button. */
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon = Inbox,
  title,
  description,
  actionLabel,
  onAction,
  actionIcon,
  action,
  className,
}) => {
  return (
    <div
      className={cn(
        'bg-card text-card-foreground border border-border rounded-2xl p-12 text-center flex flex-col items-center justify-center max-w-md mx-auto my-6 shadow-xs',
        className
      )}
    >
      <div className="h-14 w-14 rounded-2xl bg-indigo-500/10 border border-indigo-500/20 flex items-center justify-center text-indigo-500 dark:text-indigo-400 mb-4 shadow-inner">
        <Icon className="h-7 w-7" />
      </div>

      <h4 className="text-lg font-semibold text-foreground tracking-tight">{title}</h4>
      <p className="text-sm text-muted-foreground mt-1.5 leading-relaxed max-w-sm">{description}</p>

      {action ? (
        <div className="mt-6">{action}</div>
      ) : (
        actionLabel &&
        onAction && (
          <div className="mt-6">
            <Button onClick={onAction} leftIcon={actionIcon} size="md">
              {actionLabel}
            </Button>
          </div>
        )
      )}
    </div>
  );
};
